import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import SVG from 'react-inlinesvg';

import './index.css';
import Button from '../button';
import laptop from '../../images/web/laptop-min.png';
import fragaria from '../../images/web/fragaria-min.png';
import tender from '../../images/web/tender-min.png';
import rasa from '../../images/web/rasa-min.png';
import phones from '../../images/mobile/phones.png';
import taxi from '../../images/mobile/taxi.png';
import zimbara from '../../images/mobile/zimbara.png';
import downloadApp from '../../images/mobile/download-app.svg';
import anetworkMoBile from '../../images/mobile/anetwork-mobile.png';
import taxiMobile from '../../images/mobile/taxi-mobile.png';
import zimbaraMobile from '../../images/mobile/zimbara-mobile.png';

class TechnologiesCarousel extends React.Component {
  getSlides = () => {
    const webSlide1 =
      <div className="techcarousel__web__slide1" key={Math.random()}>
        <div className="techcarousel__web__slide1__wrapper">
          <div className="techcarousel__web__slide1__info">
            <span className="techcarousel__web__slide1__title">Radar Movie</span><br />
            <span className="techcarousel__web__slide1__subtitle">{localStorage.getItem('lang') == 'ru'? 'домашний кинотеатр':'home cinema'}</span>
            <div className="techcarousel__web__slide1__mobImage" >
              <img src={laptop} alt="laptop" />
            </div>
            <p className="techcarousel__web__slide1__description">
            {localStorage.getItem('lang') == 'ru'? 'Бесплатный онлайн-кинотеатр. Смотри любимые фильмы и передачи не в удобной форме':
            'Free online movie theater. Watch your favorite movies and shows in a bad shape'}</p>
            <p className="techcarousel__web__slide1__description">
            {localStorage.getItem('lang') == 'ru'? 'Просмотр доступен через сайт проекта и приложение для всех популярных мобильных платформ. Приложение можно подключить к интеллектуальным телевизорам.':
            'Viewing is available through the project website and application for all popular mobile platforms. The application can be connected to smart TVs.'}
            </p>
            <p className="techcarousel__web__slide1__description techcarousel__web__slide1__description-last">
            {localStorage.getItem('lang') == 'ru'? 'Простые настройки и функциональные возможности позволяют использовать приложение даже ребенку.':
            'Simple settings and functionalities allow even a child to use the application.'}
            </p>
            <Button handler={this.props.redirectToPortfolio}>{localStorage.getItem('lang') == 'ru'? 'Все проекты':'All projects'}</Button>
          </div>
          <div className="techcarousel__web__slide1__laptop__wrapper">
            <img src={laptop} alt="laptop" className="techcarousel__web__slide1__laptop" />
          </div>
        </div>
      </div>;
    const webSlide2 =
      <div className="techcarousel__web__slide1" key={Math.random()}>
        <div className="techcarousel__web__slide1__wrapper">
          <div className="techcarousel__web__slide1__info">
            <span className="techcarousel__web__slide1__title">Rasa Visual Board</span><br/>
            <span className="techcarousel__web__slide1__subtitle">{localStorage.getItem('lang') == 'ru'? 'автоматизация любых бизнес процессов':'automation of any business process'}</span>
            <div className="techcarousel__web__slide1__mobImage" >
              <img src={rasa} alt="rasa-bord" />
            </div>
            <p className="techcarousel__web__slide1__description">
            {localStorage.getItem('lang') == 'ru'? 'Проект создан решать и автоматизировать самые сложные бизнес-задачи.':
            'The project is created to solve and automate the most difficult business issues. '}
                </p>
            <p className="techcarousel__web__slide1__description">
            {localStorage.getItem('lang') == 'ru'? 'Программа представляет собой модульную систему для возможности ведения бизнеса и делигирования задач. Управление бизнес-процессами и их гибкая настройка.':
            'The program is a modular system for business ability and task sharing. Business process management and flexibility.'}
                </p>
            <p className="techcarousel__web__slide1__description techcarousel__web__slide1__description-last">
            {localStorage.getItem('lang') == 'ru'? 'Создание и ведение базы данных, просмотра и работы с документами в системе, администрирования входящих закупок, возможности настройки фильтров для комфортной работы менеджера.':
            'Creation and maintenance of a database, viewing and working with documents in the system, administration of incoming purchases, possibility of setting filters for comfortable work of the manager.'}
                </p>
            <Button handler={this.props.redirectToPortfolio}>{localStorage.getItem('lang') == 'ru'? 'Все проекты':'All projects'}</Button>
          </div>
          <div className="techcarousel__web__slide1__laptop__wrapper">
            <img src={rasa} alt="" className="techcarousel__web__slide1__laptop" />
          </div>
        </div>
      </div>;
    const webSlide3 =
      <div className="techcarousel__web__slide1" key={Math.random()}>
        <div className="techcarousel__web__slide1__wrapper">
          <div className="techcarousel__web__slide1__info">
            <span className="techcarousel__web__slide1__title">in Tender</span><br/>
            <span className="techcarousel__web__slide1__subtitle">{localStorage.getItem('lang') == 'ru'? 'информация о тендерах, проводимых в России.':'information about tenders held in Russia.'}</span>
            <div className="techcarousel__web__slide1__mobImage" >
              <img src={tender} alt="inTender" />
            </div>
            <p className="techcarousel__web__slide1__description">
            {localStorage.getItem('lang') == 'ru'? 'Система ведет сбор информации обо всех тендерах в России и неприрывно оповещает о них наших клиентов.':
            'The system collects information about all tenders in Russia and notifies our clients about them. '}              
                    </p>
            <p className="techcarousel__web__slide1__description">
            {localStorage.getItem('lang') == 'ru'? '«inTender» позволяет оптимизировать процесс поиска, выбора и работы с необходимым тендером. Минимализм и функциональность системы гарантирует легкость в настройке и управлении.':
            '«inTender» allows to optimize the process of search, selection and work with the necessary tender. Minimalism and functionality of the system guarantee easy adjustment and control.'}
                    </p>
            <p className="techcarousel__web__slide1__description techcarousel__web__slide1__description-last">
            {localStorage.getItem('lang') == 'ru'? 'Проект работает на платформах iOS | Android, так же доступна Web-версия.':'The project runs on iOS | Android platforms as well as the Web version.'}
                    </p>
            <Button handler={this.props.redirectToPortfolio}>{localStorage.getItem('lang') == 'ru'? 'Все проекты':'All projects'}</Button>
          </div>
          <div className="techcarousel__web__slide1__laptop__wrapper">
            <img src={tender} alt="inTender" className="techcarousel__web__slide1__laptop" />
          </div>
        </div>
      </div>;
    const webSlide4 =
      <div className="techcarousel__web__slide1" key={Math.random()}>
        <div className="techcarousel__web__slide1__wrapper">
          <div className="techcarousel__web__slide1__info">
            <span className="techcarousel__web__slide1__title">{localStorage.getItem('lang') == 'ru'? 'Фрагария':'Fragaria'}</span><br/>
            <span className="techcarousel__web__slide1__subtitle">{localStorage.getItem('lang') == 'ru'? 'сайт компаний-парнеров по выращиванию ягоды':'the site of the fruit-growing partner companies'}</span>
            <div className="techcarousel__web__slide1__mobImage" >
              <img src={fragaria} alt="Fragaria" />
            </div>
            <p className="techcarousel__web__slide1__description">
            {localStorage.getItem('lang') == 'ru'? ' Проект представляет собой сайт, функционально разделенный на два направления: компоративную часть и информационную.  Каждый раздел имеет свою структуру и целевую аудиторию.':
            'The project is a site divided functionally into two areas: the composing part and the information part. Each section has its own structure and target audience.'}
                        </p>
            <p className="techcarousel__web__slide1__description">
            {localStorage.getItem('lang') == 'ru'? 'Раздвоенный сайт мы привели к единому минималистичному дизайну, что позволило сохранить стилистику, при этом раздели входящие потоки.':
            'The split site led to a single minimalist design, which allowed to keep the stylistics while separating the incoming flows.'}
                        </p>
            <p className="techcarousel__web__slide1__description techcarousel__web__slide1__description-last">
            {localStorage.getItem('lang') == 'ru'? 'Дополнительные страницы подробно описывают продукты, стратегию развития и возможности для сотрудничества с компанией.':
            'Additional pages describe in detail the products, development strategy and possibilities for cooperation with the company.'}
                        </p>
            <Button handler={this.props.redirectToPortfolio}>{localStorage.getItem('lang') == 'ru'? 'Все проекты':'All projects'}</Button>
          </div>
          <div className="techcarousel__web__slide1__laptop__wrapper">
            <img src={fragaria} alt="Fragaria" className="techcarousel__web__slide1__laptop" />
          </div>
        </div>
      </div>;
    const mobileSlide1 =
      <div className="techcarousel__mobile__slide1" key={Math.random()}>
        {/* <button onClick={() => this.Carousel._slidePrev()}>Prev button</button>
        <button onClick={() => this.Carousel._slideNext()}>Next button</button> */}
        <div className="techcarousel__mobile__slide1__wrapper">
          <div className="techcarousel__mobile__slide1__info">
            <span className="techcarousel__mobile__slide1__title">Anetwork</span><br/>
            <span className="techcarousel__mobile__slide1__subtitle">{localStorage.getItem('lang') == 'ru'? 'мобильный личный кабинет':'personal mobile account'}</span>
            <img src={anetworkMoBile} alt="anetwork MoBile" className="techcarousel__mobile__slide1__image-mobile" />
            <p className="techcarousel__mobile__slide1__description">
            {localStorage.getItem('lang') == 'ru'? 'Удобный сервис предоставляет возможность просмотра текущего баланса, информации о подключенных услугах, истории платежей.':
            'Convenient service of mobile personal account for users of Internet-providers. Provides the possibility to view the current balance sheet, information about connected services, payment history.'}
            </p>
            <p className="techcarousel__mobile__slide1__description techcarousel__mobile__slide1__description-last">
            {localStorage.getItem('lang') == 'ru'? 'Мы предлагаем приложение для интернет-провайдеров по предоставлению IP телефонии и сети интернет.':
            'We offer a service for Internet service providers providing IP-telephony and Internet network.'}
            </p>
            <Button handler={this.props.redirectToPortfolio}>{localStorage.getItem('lang') == 'ru'? 'Все проекты':'All projects'}</Button>
            <div className="techcarousel__mobile__slide1__download-inner" onClick={this.props.openQrModal}>
              <SVG
                src={downloadApp}
                className="techcarousel__mobile__slide1__download__icon"
                alt="QR code" />
              <span className="techcarousel__mobile__slide1__download__label">{localStorage.getItem('lang') == 'ru'? 'Скачать приложение':'Download the app'}</span>
            </div>
          </div>
          <div>
            <img src={phones} alt="phones" className="techcarousel__mobile__slide1__laptop" />
          </div>
        </div>
      </div>;
    const mobileSlide2 =
      <div className="techcarousel__mobile__slide1" key={Math.random()}>
        <div className="techcarousel__mobile__slide1__wrapper">
          <div className="techcarousel__mobile__slide1__info">
            <span className="techcarousel__mobile__slide1__title">{localStorage.getItem('lang') == 'ru'? 'Такси 306':'Taxi 360'}</span><br/>
            <span className="techcarousel__mobile__slide1__subtitle">{localStorage.getItem('lang') == 'ru'? 'заказ такси в одно нажатие':'take it for one click'}</span>
            <img src={taxiMobile} alt="mobile taxi" className="techcarousel__mobile__slide1__image-mobile" />
            <p className="techcarousel__mobile__slide1__description">
            {localStorage.getItem('lang') == 'ru'? 'Такси 306— это сервис, который позволяет вызвать удобное такси по выгодным тарифам без звонка диспетчеру.':
            'Taxi 306 is a service that allows to take a taxi at favourable rates without calling the dispatcher. '}
            </p>
            <p className="techcarousel__mobile__slide1__description techcarousel__mobile__slide1__description-last">
            {localStorage.getItem('lang') == 'ru'? 'Приложение разработано для платформ iOS | Android.':
            'The application runs on iOS | Android platforms.'}
            </p>
            <Button handler={this.props.redirectToPortfolio}>{localStorage.getItem('lang') == 'ru'? 'Все проекты':'All projects'}</Button>
            <div className="techcarousel__mobile__slide1__download-inner" onClick={this.props.openQrModal}>
              <SVG
                src={downloadApp}
                className="techcarousel__mobile__slide1__download__icon" alt="QR code" />
              <span className="techcarousel__mobile__slide1__download__label">{localStorage.getItem('lang') == 'ru'? 'Скачать приложение':'Download the app'}</span>
            </div>
          </div>
          <div>
            <img src={taxi} alt="taxi mobile" className="techcarousel__mobile__slide1__laptop" />
          </div>
        </div>
      </div>;
    const mobileSlide3 =
      <div className="techcarousel__mobile__slide1" key={Math.random()}>
        <div className="techcarousel__mobile__slide1__wrapper">
          <div className="techcarousel__mobile__slide1__info">
            <span className="techcarousel__mobile__slide1__title">Zimbara Goromi</span><br/>
            <span className="techcarousel__mobile__slide1__subtitle">{localStorage.getItem('lang') == 'ru'? 'древние легенды загадочных миров':
            'ancient legends of mysterious worlds'}</span>
            <img src={zimbaraMobile} alt="zimbara goromi app" className="techcarousel__mobile__slide1__image-mobile" />
            <p className="techcarousel__mobile__slide1__description">
            {localStorage.getItem('lang') == 'ru'? 'Проект представляет собой интернет-магазин продажи детских книг. Все книги проиллюстрированы художниками из разных стран мира. Проект объединил художников-профессионалов и любителей из 44 государств.':
            'The project is an online store for children’s books. All the books are illustrated by artists from the whole world.'}     
            </p>
            <p className="techcarousel__mobile__slide1__description">
            {localStorage.getItem('lang') == 'ru'? 'Электронные книги на разных языках, яркие иллюстрации авторами которых являются дети.':
            'The project brought together professional and amateur artists from 44 countries. Electronic books in different languages, illustrated by children.'}
            </p>
            <p className="techcarousel__mobile__slide1__description techcarousel__mobile__slide1__description-last">
            {localStorage.getItem('lang') == 'ru'? 'Нажав кнопку «скачать», вы становитесь частью огромного общего дела – ZIMBARA GOROMI.':
            'By pressing the button «download», you become part of a huge common cause - ZIMBARA GOROMI.'}
            </p>
            <Button handler={this.props.redirectToPortfolio}>{localStorage.getItem('lang') == 'ru'? 'Все проекты':'All projects'}</Button>
            <div className="techcarousel__mobile__slide1__download-inner" onClick={this.props.openQrModal}>
              <SVG
                src={downloadApp}
                className="techcarousel__mobile__slide1__download__icon" />
              <span className="techcarousel__mobile__slide1__download__label">{localStorage.getItem('lang') == 'ru'? 'Скачать приложение':'Download the app'}</span>
            </div>
          </div>
          <div>
            <img src={zimbara} alt="zimbara goromi app" className="techcarousel__mobile__slide1__laptop" />
          </div>
        </div>
      </div>;
    const webSlides = [webSlide1, webSlide2, webSlide3, webSlide4];
    const mobilesSlides = [mobileSlide1, mobileSlide2, mobileSlide3];
    return this.props.tech === "mobile" ? mobilesSlides : webSlides;
  }
  render() {
    return (
      <div className={["techcarousel", this.props.tech === "mobile" ? "techcarousel__mobile" : "techcarousel__web"].join(" ")}>
        <AliceCarousel
          dotsDisabled={true}
          ref={el => this.Carousel = el}>
          {this.getSlides()}

        </AliceCarousel>
        {/* <div className="techcarousel__mobile__slide1__download__wrapper">
        </div> */}
        <Button handler={this.props.redirectToPortfolio}>{localStorage.getItem('lang') == 'ru'? 'Все проекты':'All projects'}</Button>
        <div className="techcarousel__mobile__slide1__download" onClick={this.props.openQrModal}>
          <SVG
            src={downloadApp}
            className="techcarousel__mobile__slide1__download__icon" />
          <span className="techcarousel__mobile__slide1__download__label">{localStorage.getItem('lang') == 'ru'? 'Скачать приложение':'Download the app'}</span>
        </div>

      </div>
    )
  }
}

export default TechnologiesCarousel;



// WEBPACK FOOTER //
// ./src/components/technologiesCarousel/index.jsx